import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { fetchWithAuth } from "../api/fetchWithAuth";

function EraTestCaseFormModal({ show, onClose, onSaved, testCase }) {
  const [form, setForm] = useState({
    ft_number: "",
    tc_number: "",
    tc_title: "",
    step_count: "",
    dmi_in_count: "",
    dmi_out_count: ""
  });

  useEffect(() => {
    if (!testCase) return;

    setForm({
      ft_number: testCase.ft_number ?? "",
      tc_number: testCase.tc_number ?? "",
      tc_title: testCase.tc_title ?? "",
      step_count: testCase.step_count ?? "",
      dmi_in_count: testCase.dmi_in_count ?? "",
      dmi_out_count: testCase.dmi_out_count ?? ""
    });
  }, [testCase, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((current) => ({
      ...current,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    const res = await fetchWithAuth(`/api/era-test-cases/${testCase.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ft_number: form.ft_number.trim(),
        tc_number: form.tc_number.trim(),
        tc_title: form.tc_title.trim(),
        step_count: form.step_count,
        dmi_in_count: form.dmi_in_count,
        dmi_out_count: form.dmi_out_count
      })
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      alert(error?.error || "Save failed");
      return;
    }

    onSaved();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit ERA Test Case</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Feature</Form.Label>
            <Form.Control
              name="ft_number"
              value={form.ft_number}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>TC number</Form.Label>
            <Form.Control
              name="tc_number"
              value={form.tc_number}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="tc_title"
              value={form.tc_title}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Step count</Form.Label>
            <Form.Control
              type="number"
              min="0"
              name="step_count"
              value={form.step_count}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>DMI IN count</Form.Label>
            <Form.Control
              type="number"
              min="0"
              name="dmi_in_count"
              value={form.dmi_in_count}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>DMI OUT count</Form.Label>
            <Form.Control
              type="number"
              min="0"
              name="dmi_out_count"
              value={form.dmi_out_count}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="success" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EraTestCaseFormModal;
